export function RegisterFields({ f, set }) {
  return (
    <>
      <div className="mb-3"><label className="text-caption block mb-1.5">Full Name</label><input required value={f.full_name} onChange={set("full_name")} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F]" data-testid="reg-name" /></div>
      <div className="mb-3"><label className="text-caption block mb-1.5">Organization</label><input value={f.organization} onChange={set("organization")} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F]" data-testid="reg-org" /></div>
      <div className="mb-3"><label className="text-caption block mb-1.5">Role</label>
        <select value={f.role} onChange={set("role")} className="w-full border border-slate-300 px-3 py-2.5 outline-none focus:border-[#0A192F] bg-white" data-testid="reg-role">
          <option value="attorney">Attorney</option><option value="va_agent">VA-Accredited Agent</option><option value="client">Client / Veteran</option><option value="staff_rn">Staff RN</option>
        </select>
      </div>
    </>
  );
}
